import { JsLineDec } from '../json-interface';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ArmaServConnection } from '../info-connection';

const CST_ARM_NOFIRSTPRODUCT = 4000; // 4000 = NoFirstProduct dans armaor, c'est toujours 4000

export class CProduct {

  /**
   * Crée un produit CProduct à partir d'une ligne de décorticage format JSON
   * @param infoDataSnap une ligne de déco de produit format JSON
   * @returns Un produit chargé
   */
   public static LoadFromArmaor(infoDataSnap: JsLineDec): CProduct {
      const product = new CProduct();
      product.loadFromJsLineDec(infoDataSnap);
      return product;
  }

  private idLineDB: number = 0;

  mProductCode: string = '';
  mLabel: string = '';
  mFamily: string = '';
  mQty: number = 0;
  mUnit1: string = '';
  mUnit2: string = '';
  mUnitUsed: string = '';
  /**Image télécharger à part */
  mImage: SafeUrl | null = null;
  mNoLine: number = 0;
  mU1Weight: number = 0;
  mU1ToU2: number = 1;

  constructor() { }

  public loadFromJsLineDec(jsLineDec: JsLineDec) {
    this.idLineDB = jsLineDec.idLineDB;
    if (jsLineDec.ProductLine) {
      this.mProductCode = jsLineDec.ProductLine.ProductCode;
      this.mLabel = jsLineDec.ProductLine.ProductLabel;
      this.mQty = jsLineDec.ProductLine.ProductQty;
      this.mUnit1 = jsLineDec.ProductLine.ProductU1;
      this.mUnit2 = jsLineDec.ProductLine.ProductU2;
      this.mUnitUsed = jsLineDec.ProductLine.ProductUnitUsed;
      this.mNoLine = parseInt(jsLineDec.NoLine, 10);
      this.mU1Weight = jsLineDec.ProductLine.ProductU1Weight;
      this.mU1ToU2 = jsLineDec.ProductLine.ProductU1ToU2;
    }
  }

  public async loadImageproduct(http: HttpClient, domSanitizer: DomSanitizer): Promise<SafeUrl | null> {
      try {
          this.mImage = await ArmaServConnection.getSafeUrlImgFromDatasnap(http, domSanitizer, 'GetProductImage', [this.mProductCode]);
      } catch (e) {
          console.error(e);
      }
      return this.mImage;
  }

  public toJsLineDec(noLine: number): JsLineDec {
      return {
          idLineDB: this.idLineDB,
          Elem: this.elem,

          NoLine: noLine.toString(),

          ErrorLine: undefined,

          SmallComment: undefined,

          ProductLine: {
            ProductCode: this.mProductCode,
            ProductLabel: this.mLabel,
            ProductQty: this.mQty,
            ProductUnitUsed: this.mUnitUsed,
            ProductU1Weight: this.mU1Weight,
            Rep: '',
            ProductU1: this.mUnit1,
            ProductU2: this.mUnit2,
            ProductU1ToU2: this.mU1ToU2
          }
      };
  }

  get totalWeight(): number {
    let result: number = this.mU1Weight * this.mQty;
    if (this.mUnitUsed == this.mUnit2) {
      if (this.mU1ToU2 == 0) {
        result = 0;
      } else {
        result /= this.mU1ToU2;
      }
    }
    return result;
  }

  get elem(): number {
    return CST_ARM_NOFIRSTPRODUCT;
  }

  public isEmpty(): boolean {
      return this.mProductCode == '';
  }
}
